import n from "styled-components";
import { Button as e } from "./atoms-v26.js";
import { Tag as o } from "./atoms-v241.js";
import { Icon as a } from "./atoms-v217.js";
const c = n.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 16px 0;
  width: 100%;

  ${({ $size: t }) => t === "small" && `
    height: fit-content;
    padding: 12px;
  `}
`, s = n.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: center;

  ${({ $size: t }) => t === "small" && `
    justify-content: space-between;
    width: 100%;
  `}
`, x = n.div`
  align-items: center;
  background-color: ${({ $colorTheme: t, theme: i }) => i.get(`tokens.surface.${t}.layer01`)};
  border-radius: ${({ theme: t }) => t.get("tokens.radius.buttonFullRounded")}px;
  display: flex;
  justify-content: center;
  padding: 4px;

  ${({ $size: t }) => t === "small" && `
    margin: auto;
    padding-left: 15px;
    text-align: center;
    width: fit-content;
  `}
`, g = n(e)`
  min-height: 40px;
  min-width: 40px;
  padding: 14px;
`, m = n(e)`
  padding: 13px 18px;
  text-decoration: none;

  ${({ $size: t }) => t === "small" && `
    padding: 6px 9px;
  `}
`, u = n.div`
  display: inline-block;
  margin-left: ${({ $size: t }) => t === "small" ? "3px" : "8px"};
  position: relative;
`, f = n(o)`
  border-radius: 1000px;
  box-sizing: border-box;
  height: 24px;
  position: absolute;
  right: -8px;
  top: -8px;
  width: 24px;

  .tag-content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    padding-bottom: 0;
    width: 100%;
  }
`, h = n.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 2px;
`, y = n.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`, b = n(a)`
  opacity: ${({ $isVisible: t }) => t ? 1 : 0};
`;
export {
  b as BackButtonIcon,
  g as IconButton,
  x as SearchArea,
  m as SearchBarButton,
  c as SearchBarWrapper,
  h as SmallButtonContainer,
  y as SmallButtonRow,
  s as StyledSearchBar,
  f as StyledTag,
  u as TagContainer
};
